import React from 'react'
import { DollarSign, CheckCircle } from 'lucide-react'
import { useVendorDashboard } from '../VendorDashboard'

const VendorPayments = () => {
  const { vendorData } = useVendorDashboard()

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Payment History</h3>
      
      {vendorData.payments.length === 0 ? (
        <div className="text-center py-12">
          <DollarSign className="w-16 h-16 text-gray-400 mx-auto mb-4" />
          <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            No payments yet
          </h4>
          <p className="text-gray-600 dark:text-gray-300">
            Your payment history will appear here once you make your first payment.
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {vendorData.payments.map((payment, index) => (
            <div key={index} className="bg-white dark:bg-slate-800 rounded-lg p-4 shadow-sm border border-gray-200 dark:border-gray-700">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-success-100 dark:bg-success-900/30 rounded-lg flex items-center justify-center mr-4">
                    <CheckCircle className="w-6 h-6 text-success-600" />
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-900 dark:text-white">{payment.description}</h4>
                    <p className="text-sm text-gray-600 dark:text-gray-300">{payment.date}</p>
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-semibold text-gray-900 dark:text-white">₹{payment.amount}</div>
                  <div className="text-sm text-success-600">Paid</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default VendorPayments

